import _ from 'underscore';
import DeletionSource from "models/audioEditor/DeletionSource";


const CLASSNAME = "AISuggestionDeletionSource";
const AISuggestionDeletionSource =  DeletionSource.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        DeletionSource.apply(this, [attributes, options]);
    },

    getConstructor : function(){
        return AISuggestionDeletionSource;
    },

    clone: function(){
        return new AISuggestionDeletionSource(this.toJSON());
    },

    getReason: function(){
        return this.get("reason");
    },

    setReason: function(reason) {
        this.set("reason", reason);
    },

    getSearchedElementCategory: function(){
        return this.get("searchedElementCategory");
    },

    setSearchedElementCategory: function(category) {
        this.set("searchedElementCategory", category);
    },

    getConfidence: function(){
        return this.get("confidence");
    },

    setConfidence: function(confidence) {
        this.set("confidence", confidence);
    },
    
    getStreamlinedSuggestionConfidence: function(){
        return this.get("streamlinedSuggestionConfidence");
    },

    setStreamlinedSuggestionConfidence: function(streamlinedSuggestionConfidence) {
        this.set("streamlinedSuggestionConfidence", streamlinedSuggestionConfidence);
    },

    getIsCustomType: function(){
        return this.get("isCustomType");
    },

    setIsCustomType: function(isCustomType) {
        this.set("isCustomType", isCustomType);
    },

    getCustomTypeLabel: function(){
        return this.get("customTypeLabel");
    },

    setCustomTypeLabel: function(customTypeLabel) {
        this.set("customTypeLabel", customTypeLabel);
    },

    getRecommendation: function(){
        return this.get("recommendation");
    },

    setRecommendation: function(recommendation) {
        this.set("recommendation", recommendation);
    },

    getUid: function(){
        return this.get("uid");
    },

    setUid: function(uid) {
        this.set("uid", uid);
    },

    getSearchRequestId: function(){
        return this.get("searchRequestId");
    },

    setSearchRequestId: function(searchRequestId) {
        this.set("searchRequestId", searchRequestId);
    },

    afterInstanceCreatedFromConstructorForCloning : function(createdClonedInstance){

    },

    getSerializedData : function(){
        const serializedData = DeletionSource.prototype.getSerializedData.call(this);
        serializedData.classname =  AISuggestionDeletionSource.CLASSNAME;
        serializedData.uid = this.getUid();
        serializedData.confidence = this.getConfidence();
        serializedData.searchedElementCategory = this.getSearchedElementCategory();
        serializedData.recommendation = this.getRecommendation();
        serializedData.reason = this.getReason();
        serializedData.streamlinedSuggestionConfidence = this.getStreamlinedSuggestionConfidence();
        serializedData.isCustomType = this.getIsCustomType();
        serializedData.customTypeLabel = this.getCustomTypeLabel();
        serializedData.searchRequestId = this.getSearchRequestId();
        return serializedData;
    },

    restoreFromSerializedData: function(serializedData){
        DeletionSource.prototype.restoreFromSerializedData.call(this, serializedData);
        this.setUid(serializedData.uid);
        this.setConfidence(serializedData.confidence);
        this.setSearchedElementCategory(serializedData.searchedElementCategory);
        this.setRecommendation(serializedData.recommendation);
        this.setReason(serializedData.reason);
        this.setStreamlinedSuggestionConfidence(serializedData.streamlinedSuggestionConfidence);
        this.setIsCustomType(serializedData.isCustomType);
        this.setCustomTypeLabel(serializedData.customTypeLabel);
        this.setSearchRequestId(serializedData.searchRequestId);
        return this;
    },

    afterAllInstancesCreatedFromSerializedData : function(serializedData){
        DeletionSource.prototype.afterAllInstancesCreatedFromSerializedData.call(this, serializedData);
    },


    cloneJSON: function(){
        const objJson = DeletionSource.prototype.cloneJSON.call(this);
        objJson.classname = AISuggestionDeletionSource.CLASSNAME;
        objJson.uid = this.getUid();
        objJson.confidence = this.getConfidence();
        objJson.searchedElementCategory = this.getSearchedElementCategory();
        objJson.recommendation = this.getRecommendation();
        objJson.reason = this.getReason();
        objJson.streamlinedSuggestionConfidence = this.getStreamlinedSuggestionConfidence();
        objJson.isCustomType = this.getIsCustomType();
        objJson.customTypeLabel = this.getCustomTypeLabel();
        objJson.searchRequestId = this.getSearchRequestId();
        return objJson;
    },

});

AISuggestionDeletionSource.CLASSNAME =  CLASSNAME;
export default AISuggestionDeletionSource;
